import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NotificationService } from 'src/app/services/notification-service';
import { MatDatepicker } from '@angular/material/datepicker';
import { Moment } from 'moment-timezone';
import { CommonModule, DatePipe } from '@angular/common'
import moment from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';


@Component({
  selector: 'app-suspension-schedule',
  templateUrl: './suspension-schedule.component.html',
  styleUrls: ['./suspension-schedule.component.scss'],
})

export class SuspensionScheduleComponent implements OnInit {
  currentStep = 1;
  saveSuccess = false;
  execDates: string[] = [];
  suspensionForm: FormGroup;
  data: any;
  formValue: any;
  debitDates: any[] = [];
  notificationPreferences: any[] = [{ key: 3, value: 'Email' }];
  todayDate: string;
  notificationMinDate: Date;
  suspensionMinDate: Date;
  currentMonth: Date;
  selectedMonth: Date;
  minDate: Date = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
  targetMaxDate: Date;
  isNotificationSent: boolean = false;
  isViewMode: boolean = false;
  viewOnlyProcessTypes: number[] = [5];
  processTypeValue: number;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private applicationDataService: ApplicationDataService,
    private lookUpDataService: LookupDataServiceService,
    private navigationService: NavigationService,
    private toastr: NotificationService,

  ) {

    const tomorrow = new Date();
    const now = new Date();

    tomorrow.setDate(tomorrow.getDate() + 1);
    this.todayDate = tomorrow.toISOString().split('T')[0];
    this.notificationMinDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    this.suspensionMinDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 2);
    this.currentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    this.selectedMonth = this.currentMonth;

    this.lookUpDataService.getDebitRunDateType(true).subscribe((res: any) => {
      this.debitDates = res;
    });

    this.suspensionForm = this.fb.group({
      debitOrder: ['', Validators.required],
      processType: [{ value: "3", disabled: true }],
      targetMonth: [this.currentMonth, Validators.required],
      suspensionDate: [null],
      manageSuspensionId: [0],
      batchReferenceId: [null],
      suspensionExecDates: this.fb.array([], Validators.required),
      notificationDate: [null, Validators.required],
      channel: [3]
    });
  }

  ngOnInit(): void {

    this.targetMaxDate = this.targetMaxDateMethod();

    const state = window.history.state as any;
    this.isViewMode = !!state?.viewMode;
    if (state?.suspensionData) {
      this.populateForm(state.suspensionData);
    }

    // Subscribe to targetMonth changes to validate dates
    this.suspensionForm.get('targetMonth').valueChanges.subscribe(value => {
      if (value) {
        this.validateDatesAgainstTargetMonth();
        this.updateMinDates();
      }
    });

    // Subscribe to debitOrder changes to validate dates based on debit schedule
    this.suspensionForm.get('debitOrder').valueChanges.subscribe(value => {
      if (value !== null && value !== undefined) {
        this.validateDatesAgainstDebitOrder();
        this.updateMinDates();
      }
    });
  }

  targetMaxDateMethod(): Date {
    const maxDate = new Date(this.currentMonth);
    maxDate.setMonth(maxDate.getMonth() + 5);
    return maxDate;
  }

  populateForm(data: any): void {
    console.log('Populating form with data:', data);

    const currentDate = new Date();
    this.processTypeValue = this.resolveProcessType(data);
    this.suspensionForm.patchValue({
      debitOrder: data.debitDateType,
      processType: String(this.processTypeValue),
      manageSuspensionId: data.manageSuspensionId,
      batchReferenceId: data.batchReferenceId,
      targetMonth: data.targetMonth || null,
      notificationDate: data.suspensionDate ? new Date(data.suspensionDate) : null,
    });

    if (this.isViewMode) {
      this.suspensionForm.get('debitOrder')?.disable();
      this.suspensionForm.get('processType')?.disable();
      this.suspensionForm.get('targetMonth')?.disable();
      this.suspensionForm.get('suspensionDate')?.disable();
      this.suspensionForm.get('notificationDate')?.disable();
      this.suspensionForm.get('channel')?.disable();
    } else if (this.suspensionForm.value.manageSuspensionId != 0) {
      this.suspensionForm.get('targetMonth')?.disable();
      this.suspensionForm.get('debitOrder')?.disable();
    } else {
      this.suspensionForm.get('targetMonth')?.enable();
      this.suspensionForm.get('debitOrder')?.enable();
      this.suspensionForm.get('processType')?.enable();
    }

    if (data.preNotificationDate && new Date(data.preNotificationDate) <= currentDate) {
      this.isNotificationSent = true;
    }





    const execDatesArray = this.suspensionForm.get('suspensionExecDates') as FormArray;
    execDatesArray.clear();
    this.execDates = [];
    const executionDates = Array.isArray(data.suspensionExecDates) && data.suspensionExecDates.length > 0
      ? data.suspensionExecDates
      : Array.isArray(data.suspensionDate)
        ? data.suspensionDate
        : data.suspensionDate
          ? [data.suspensionDate]
          : [];

    executionDates.forEach((date: any) => {
      const executionDate = date?.suspensionDate || date;
      if (executionDate) {
        this.addExecDate(executionDate);
      }
    });

    this.updateNotificationDate();
    // Set selected month
    if (data.targetMonth) {
      this.selectedMonth = new Date(data.targetMonth);
    }

    this.updateMinDates();
  }

  get batchSplit(): string {
    const count = this.suspensionDates.length;
    if (count === 0) return 'None';
    return count === 1 ? 'Single' : `Split ${count}`;
  }

  get execDatesArray(): FormArray {
    return this.suspensionForm.get('suspensionExecDates') as FormArray;
  }

  get suspensionDates(): string[] {
    const formValue = this.execDatesArray?.value;
    if (Array.isArray(formValue) && formValue.length > 0) {
      return formValue.map((date: any) => {
        if (date instanceof Date) {
          return this.formatDate(date);
        }
        if (typeof date === 'string') {
          const parsed = new Date(date);
          return !isNaN(parsed.getTime()) ? this.formatDate(parsed) : date;
        }
        return String(date);
      });
    }
    return this.execDates;
  }

  addExecDate(date: string | Date) {
    if (!date) {
      this.toastr.showError("Select a date");
      return;
    }

    const dateObj = date instanceof Date ? date : new Date(date);
    if (isNaN(dateObj.getTime())) {
      return;
    }

    const formattedDate = this.formatDate(dateObj);
    if (this.execDates.includes(formattedDate)) {
      return;
    }

    this.execDates.push(formattedDate);
    this.sortExecDates();
    this.updateNotificationDate();
  }

  formatDate(date: Date): string {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  private sortExecDates(): void {
    this.execDates.sort();

    const sortedDates = [...this.execDates];
    const execDatesArray = this.execDatesArray;
    execDatesArray.clear();
    sortedDates.forEach((date) => execDatesArray.push(this.fb.control(date)));
  }

  get firstsuspensionDate(): string | null {
    const dates = this.suspensionDates;
    if (dates.length === 0) {
      return null;
    }
    return dates[0];
  }

  get notificationMaxDate(): Date | null {
    const firstDate = this.firstsuspensionDate;
    if (!firstDate) {
      return null;
    }
    const maxDate = new Date(firstDate);
    maxDate.setDate(maxDate.getDate() - 1);
    return maxDate;
  }

  updateNotificationDate() {
    const notifControl = this.suspensionForm.get('notificationDate');
    if (!notifControl) {
      return;
    }

    const currentValue = notifControl.value ? new Date(notifControl.value) : null;
    const maxDate = this.notificationMaxDate;

    if (!maxDate || !currentValue) {
      return;
    }

    if (currentValue > maxDate) {
      notifControl.setValue(maxDate, { emitEvent: false });
    }
  }

  /**
   * Get minimum day of month based on debit order value
   */
  private getMinDayFromDebitOrder(): number {
    const debitValue = this.suspensionForm.get('debitOrder').value;
    const debitValueStr = String(debitValue);
    if (debitValueStr === '0') return 1;
    if (debitValueStr === '1') return 15;
    if (debitValueStr === '2') return 25;
    return 1; // default
  }

  /**
   * Check if a date is invalid based on target month and minimum day requirement
   */
  private isDateInvalidForTargetMonth(date: Date, minDayOfMonth: number): boolean {
    const targetValue = this.suspensionForm.get('targetMonth').value;
    if (!targetValue) return false;

    const targetDate = new Date(targetValue);
    const targetMonth = targetDate.getMonth();
    const targetYear = targetDate.getFullYear();

    // Check if date is before target month
    if (date.getFullYear() < targetYear ||
      (date.getFullYear() === targetYear && date.getMonth() < targetMonth)) {
      return true;
    }

    // Check if date is in target month but before minimum day
    if (date.getFullYear() === targetYear &&
      date.getMonth() === targetMonth &&
      date.getDate() <= minDayOfMonth) {
      return true;
    }

    return false;
  }

  /**
   * Validate and remove invalid dates
   */
  validateDates() {
    const minDayOfMonth = this.getMinDayFromDebitOrder();

    // Validate suspensionExecDates
    const execArray = this.execDatesArray;
    for (let i = execArray.length - 1; i >= 0; i--) {
      const dateStr = execArray.at(i).value;
      if (this.isDateInvalidForTargetMonth(new Date(dateStr), minDayOfMonth)) {
        execArray.removeAt(i);
        this.execDates.splice(i, 1);
      }
    }

    // Validate notificationDate
    const notifDate = this.suspensionForm.get('notificationDate').value;
    if (notifDate && this.isDateInvalidForTargetMonth(new Date(notifDate), minDayOfMonth)) {
      this.suspensionForm.get('notificationDate').setValue(null);
    }

    // Validate suspensionDate
    const suspDate = this.suspensionForm.get('suspensionDate').value;
    if (suspDate && this.isDateInvalidForTargetMonth(new Date(suspDate), minDayOfMonth)) {
      this.suspensionForm.get('suspensionDate').setValue(null);
    }

    this.updateNotificationDate();
  }

  validateDatesAgainstTargetMonth() {
    this.validateDates();
  }

  validateDatesAgainstDebitOrder() {
    this.validateDates();
  }

  updateMinDates() {
    const targetValue = this.suspensionForm.get('targetMonth').value;
    if (!targetValue) return;

    const targetDate = new Date(targetValue);
    const now = new Date();
    const minDayOfMonth = this.getMinDayFromDebitOrder();
    const isCurrentMonth = targetDate.getFullYear() === now.getFullYear() &&
      targetDate.getMonth() === now.getMonth();

    // Calculate notification min date
    if (isCurrentMonth) {
      this.notificationMinDate = new Date(now.getFullYear(), now.getMonth(),
        Math.max(now.getDate(), minDayOfMonth));
    } else {
      this.notificationMinDate = new Date(targetDate.getFullYear(), targetDate.getMonth(), minDayOfMonth);
    }
    this.notificationMinDate.setDate(this.notificationMinDate.getDate() + 1);
    // Suspension min date is always +1 day from notification min date
    this.suspensionMinDate = new Date(this.notificationMinDate);
    this.suspensionMinDate.setDate(this.suspensionMinDate.getDate() + 1);
  }

  cancel() {
    this.suspensionForm.patchValue({
      debitOrder: ['', Validators.required],
      processType: [{ value: 3, disabled: true }],
      targetMonth: [this.currentMonth, Validators.required],
      suspensionDate: [null],
      suspensionExecDates: this.fb.array([], Validators.required),
      notificationDate: [null, Validators.required],
      channel: 3
    });
  }

  removeExecDate(index: number) {
    this.execDates.splice(index, 1);
    this.sortExecDates();
    this.updateNotificationDate();
  }

  saveSchedule() {
    this.saveSuccess = true;
    this.formValue = this.suspensionForm.getRawValue();
    debugger
    const payload = {
      processType: this.formValue.processType,
      suspensionDates: this.suspensionDates,
      debitDate: this.formValue.debitOrder,
      notificationPreferenceType: this.formValue.channel,
      preNotificationDate: this.formValue.notificationDate ? this.formatDate(new Date(this.formValue.notificationDate)) : null,
      processStatusType: null,
      Batch: null,
      Count: null,
      filename: null,
      ManageSuspensionId: this.formValue.manageSuspensionId,
      batchReferenceId: this.formValue.batchReferenceId,
      targetMonth: this.formValue.targetMonth ? this.formatDate(new Date(this.formValue.targetMonth)) : null,
    };

    this.applicationDataService.addOrUpdateSuspension(payload).subscribe((result) => {
      this.data = result;
      if (this.data) {
        this.toastr.showSuccess("Saved Successfully")
        this.navigationService.goToSuspensionDashboard();
      }
    });
  }

  resolveProcessType(data: any): number {
    const processTypeDesc = String(data?.processTypeDesc ?? '').toLowerCase();
    if (processTypeDesc.includes('pre')) {
      return 5;
    }
    if (processTypeDesc.includes('suspension')) {
      return 3;
    }

    const rawProcessType = data?.processType ?? data?.processTypeId;
    if (rawProcessType === 5 || rawProcessType === '5') {
      return 5;
    }
    if (rawProcessType === 3 || rawProcessType === '3') {
      return 3;
    }

    return 3;
  }

  getDaysBefore(): string {
    const notifDate = this.suspensionForm.get('notificationDate')?.value;
    const firstExecDate = this.firstsuspensionDate;
    if (notifDate && firstExecDate) {
      const d1 = new Date(notifDate);
      const d2 = new Date(firstExecDate);
      const diff = Math.floor((d2.getTime() - d1.getTime()) / (1000 * 3600 * 24));
      return diff > 0 ? `${diff} days` : '0 days';
    }
    return '';
  }

  shouldShowExecutionDatesBlock(): boolean {
    const isExistingRecord = this.isViewMode || this.suspensionForm.get('manageSuspensionId')?.value !== 0;
    if (!isExistingRecord) {
      return true;
    }

    const processType = Number(this.suspensionForm.get('processType')?.value ?? 3);
    return !this.viewOnlyProcessTypes.includes(processType);
  }

  shouldShowNotificationBlock(): boolean {
    const isExistingRecord = this.isViewMode || this.suspensionForm.get('manageSuspensionId')?.value !== 0;
    if (!isExistingRecord) {
      return true;
    }

    return this.processTypeValue === 5;
  }


  setMonthAndYear(normalizedMonthAndYear: any, datepicker: MatDatepicker<any>) {
    const selected = new Date(normalizedMonthAndYear);

    const current = this.suspensionForm.get('targetMonth')?.value;
    const base = current ? new Date(current) : new Date();

    base.setMonth(selected.getMonth());
    base.setFullYear(selected.getFullYear());
    base.setDate(1); // normalize to 1st of the month

    this.suspensionForm.get('targetMonth')?.setValue(base);
    datepicker.close();
  }
}

export const MONTH_YEAR_FORMATS = {
  parse: { dateInput: 'MM/YYYY' },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-month-year-picker',
  template: `
  <mat-form-field appearance="fill" class="full-width purple-form-field" hideRequiredMarker>
    <mat-label>{{ label }}</mat-label>
    <input matInput [matDatepicker]="dp" [value]="value"
           [min]="minDate" [max]="maxDate" 
           [disabled]="isDisabled"   
           readonly>
    <mat-datepicker-toggle matSuffix [for]="dp" [disabled]="isDisabled">
    </mat-datepicker-toggle>
    <mat-datepicker #dp startView="multi-year"
      (monthSelected)="setMonthAndYear($event, dp)"
      panelClass="example-month-picker">
    </mat-datepicker>
  </mat-form-field>
`,
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MONTH_YEAR_FORMATS },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MonthYearPickerComponent),
      multi: true
    }
  ],
})
export class MonthYearPickerComponent implements ControlValueAccessor {
  @Input() label: string = 'Target Month';
  @Input() minDate: Date | null = null;
  @Input() maxDate: Date | null = null;
  isDisabled: boolean = false;
  value: Moment | null = null;

  private onChange: (val: any) => void = () => { };
  private onTouched: () => void = () => { };

  writeValue(val: any): void {
    this.value = val ? moment(val) : null;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }

  setMonthAndYear(normalizedMonthAndYear: any, datepicker: MatDatepicker<any>) {
    if (this.isDisabled) return;
    const selected = moment(normalizedMonthAndYear);
    const base = this.value ? this.value.clone() : moment();

    base.month(selected.month());
    base.year(selected.year());
    base.date(1);

    this.value = base;
    this.onChange(base.toDate());
    this.onTouched();
    datepicker.close();
  }

}
